import { HEIGHT_BOTTOM_SHEET_HANDLE, HEIGHT_TIMELINE_TAB } from '@web/ui/pages/timeline/TimelinePage.constant'

/**
 * 화면에서 바텀시트가 차지할 비율 65%
 */
export const BOTTOM_SHEET_HALF_VIEW_RATIO = 6.5 / 10

/**
 * 타임라인 리스트 페이지에서 한 세그먼트당 가져올 아이템 개수
 */
export const TIMELINE_PAGE_SIZE = 50

/** 바텀시트 내부요소 선택자 */
export const BOTTOM_SHEET_INNER_ELEM_ATTRIBUTE = '[data-rsbs-scroll="true"]'
/** 타임라인 섹션 선택자 */
export const TIMELINE_SECTION_ELEM_ATTR = 'timeline'

/**
 * 타임라인 리스트 > 중심 결정에 쓰일 마커 개수
 */
export const MAP_ZOOM_TARGET_MARKER_SIZE = 40

/**
 * 방문상세 요약뷰(미니뷰) 높이
 */
export const MINI_VIEW_HEIGHT_VISIT_DETAIL = 260 - HEIGHT_BOTTOM_SHEET_HANDLE

/**
 * 타임라인 미니뷰 높이 (임의설정)
 */
export const MINI_VIEW_HEIGHT_TIMELINE = 40

/**
 * 타임라인 리스트 > 지도뷰에 노출할 최대 업커밍 마커 개수
 */
export const MAX_UPCOMING_MARKER = 20

/**
 * 타임라인 지도뷰 최대 이미지 마커 노출 개수
 */
export const MAX_IMAGE_MARKER_COUNT = 5

/**
 * 점마커간 겹침으로 취급할 임계 거리(미터). 2.5m 보다 가까우면 겹침으로 판단
 */
export const DOT_MARKER_OVERLAPPING_DISTANCE = 2.5

/**
 * 타임라인리스트 미니뷰 높이
 */
export const MINI_VIEW_HEIGHT_LIST = HEIGHT_TIMELINE_TAB

/**
 * 타임라인 지도뷰 갱신시 최소 줌레벨
 */
export const MAP_MIN_ZOOM_LEVEL = 8
